/*
 * Homeline product page 1a (sections/hl-main-product.liquid).
 *
 *   Variants   options + colour pick the variant; price, RRP, Afterpay,
 *              the one stock line, cart flags, image, URL and the sticky
 *              bar follow it.
 *   Colour     In stock / Made to order behind a segmented control whose
 *              thumb is a spring (response 0.35s, damping 1), draggable with
 *              rubber-banding and velocity projection, as the handoff's
 *              segAnimTo / segDown. A sideways swipe on the swatches also
 *              switches group.
 *   Gallery    track of slides; thumbs and arrows on desktop, dots and swipe
 *              on phones.
 *   Features   Key features row: prev / next by two cards, mouse drag with
 *              snap to the nearest card on release.
 *   Cart       the product form posts to /cart/add.js with the drawer's
 *              sections, so the drawer opens as it does everywhere else.
 *              Complete the room adds every ticked piece in one request.
 *   Delivery   postcode check against the shared zone table
 *              (snippets/hl-delivery-zones); the postcode is saved into the
 *              cart's own options, like the delivery band does.
 *   Sticky bar shown once the main Add to cart scrolls under the header.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-hl-pdp]');
  if (!root || root.__hlPdp) return;
  root.__hlPdp = true;

  var data;
  try {
    data = JSON.parse(root.querySelector('[data-hl-pdp-json]').textContent);
  } catch (e) {
    return;
  }

  var OPTS_KEY = 'homeline_cart_opts_v1';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMq = window.matchMedia('(max-width: 960px)');

  function $(sel, ctx) {
    return (ctx || root).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function noMotion() {
    return !!(reduced && reduced.matches);
  }

  // Matches money_without_trailing_zeros: $1,299 / $1,299.50.
  function money(cents) {
    var n = Math.round(cents) / 100;
    var whole = Math.floor(n);
    var frac = Math.round((n - whole) * 100);
    var s = '$' + whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return frac ? s + '.' + (frac < 10 ? '0' : '') + frac : s;
  }

  function headerH() {
    return mobileMq.matches ? 60 : 72;
  }

  function smoothTo(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 96;
    window.scrollTo({ top: top, behavior: noMotion() ? 'auto' : 'smooth' });
  }

  /* ================= Variant model ================= */

  var variants = data.variants || [];
  var cIdx = typeof data.colourIndex === 'number' ? data.colourIndex : -1;

  function isSpecial(v) {
    if (!v) return false;
    if (data.prodMto || v.mto) return true;
    return typeof v.stock === 'number' && v.stock <= 0;
  }
  // No stock on hand: tracked and at zero, whatever the selling policy.
  function zeroStock(v) {
    return !!v && typeof v.stock === 'number' && v.stock <= 0;
  }
  // Colour groups, as the old swatch grid had them: anything with no stock
  // on hand (or flagged made to order) is Made to order. Shopify may still
  // refuse to sell it ("stop selling when out of stock"); that shows on the
  // status line and the button, not by striking the swatch out.
  function groupOf(v) {
    if (!v) return 'out';
    if (isSpecial(v) || zeroStock(v)) return 'mto';
    return v.available ? 'in' : 'out';
  }
  function findVariant(sel) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (variants[i].options[j] !== sel[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return variants[i];
    }
    return null;
  }
  // The variant pairing `value` at option `idx` with the rest of `sel`, or,
  // when that combination doesn't exist, the closest one that does.
  function closest(sel, idx, value) {
    var next = sel.slice();
    next[idx] = value;
    var exact = findVariant(next);
    if (exact) return exact;
    var best = null;
    var bestScore = -1;
    variants.forEach(function (v) {
      if (v.options[idx] !== value) return;
      var score = 0;
      for (var i = 0; i < next.length; i++) if (i !== idx && v.options[i] === next[i]) score += 2;
      var g = groupOf(v);
      if (g === 'in') score += 1;
      if (g === 'out') score -= 4;
      if (score > bestScore) {
        bestScore = score;
        best = v;
      }
    });
    return best;
  }

  var idInput = $('[data-hl-pdp-id]');
  var current =
    variants.filter(function (v) {
      return idInput && String(v.id) === idInput.value;
    })[0] || variants[0];
  var sel = current ? current.options.slice() : [];

  function seriesOf(v) {
    return (v && v.series) || '';
  }
  // "COMO Grey" with series "COMO" reads "COMO · Grey".
  function colourName(v) {
    if (!v || cIdx < 0) return '';
    var val = v.options[cIdx] || '';
    var s = seriesOf(v);
    if (s && val.indexOf(s) === 0) return s + ' · ' + val.slice(s.length).trim();
    return val;
  }

  /* ================= Colour groups + spring segmented control ================= */

  var colour = $('[data-hl-pdp-colour]');
  var seg = colour && $('[data-hl-seg]', colour);
  var thumb = seg && $('[data-hl-seg-thumb]', seg);
  var swatchWrap = colour && $('[data-hl-swatches]', colour);
  var activeGroup = colour ? colour.getAttribute('data-open-group') || 'in' : 'in';
  var segPos = null;
  var segRaf = 0;

  function segTravel() {
    return thumb ? thumb.offsetWidth : 0;
  }
  function segSingle() {
    return !seg || seg.hasAttribute('data-single');
  }
  // The thumb never leaves the track: drags stop at either end and the
  // spring settles without overshooting past them.
  function setThumb(x) {
    if (!thumb) return;
    var w = segTravel();
    x = Math.max(0, Math.min(w, x));
    thumb.style.transform = 'translateX(' + x + 'px)';
  }
  function paintSegButtons() {
    if (!seg) return;
    $$('[data-hl-seg-btn]', seg).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-hl-seg-btn') === activeGroup ? 'true' : 'false');
    });
  }
  function setGroup(g) {
    if (g === activeGroup) return;
    activeGroup = g;
    paintSegButtons();
    paintSwatches();
  }

  // Spring to side `idx` (0 in stock, 1 made to order), starting from the
  // thumb's current on-screen position and carrying `v0` px/s.
  function segAnimTo(idx, v0) {
    if (!thumb || segSingle()) return;
    var w = segTravel();
    cancelAnimationFrame(segRaf);
    var target = idx * w;
    if (!w || noMotion()) {
      segPos = null;
      setGroup(idx ? 'mto' : 'in');
      setThumb(target);
      return;
    }
    // Start from where the thumb is now (mid-flight or resting on the other
    // side). Recorded before the group repaint so that doesn't snap it.
    var x = segPos != null ? segPos : activeGroup === 'mto' ? w : 0;
    segPos = x;
    setGroup(idx ? 'mto' : 'in');
    var v = v0 || 0;
    var om = (2 * Math.PI) / 0.35;
    var last = performance.now();
    function step(now) {
      var dt = Math.min(0.032, (now - last) / 1000);
      last = now;
      var a = -om * om * (x - target) - 2 * om * v;
      v += a * dt;
      x += v * dt;
      // Reaching an end of the track finishes the move: no bounce past it.
      if ((Math.abs(x - target) < 0.3 && Math.abs(v) < 5) || x <= 0 || x >= w) {
        setThumb(target);
        segPos = null;
        return;
      }
      segPos = x;
      setThumb(x);
      segRaf = requestAnimationFrame(step);
    }
    segRaf = requestAnimationFrame(step);
  }

  function placeThumb() {
    if (!thumb) return;
    cancelAnimationFrame(segRaf);
    segPos = null;
    setThumb(!segSingle() && activeGroup === 'mto' ? segTravel() : 0);
  }

  if (seg) {
    seg.addEventListener('pointerdown', function (e) {
      if (segSingle() || (e.pointerType === 'mouse' && e.button !== 0)) return;
      try {
        seg.setPointerCapture(e.pointerId);
      } catch (err) {}
      cancelAnimationFrame(segRaf);
      var w = segTravel();
      var start = segPos != null ? segPos : activeGroup === 'mto' ? w : 0;
      var x0 = e.clientX;
      var dragging = false;
      var pos = start;
      var hist = [{ x: e.clientX, t: performance.now() }];
      function mv(ev) {
        var dx = ev.clientX - x0;
        if (!dragging && Math.abs(dx) < 4) return;
        dragging = true;
        seg.classList.add('is-grabbing');
        var p = Math.max(0, Math.min(w, start + dx));
        pos = p;
        segPos = p;
        setThumb(p);
        hist.push({ x: ev.clientX, t: performance.now() });
        if (hist.length > 5) hist.shift();
      }
      function up(ev) {
        seg.removeEventListener('pointermove', mv);
        seg.removeEventListener('pointerup', up);
        seg.removeEventListener('pointercancel', up);
        seg.classList.remove('is-grabbing');
        if (!dragging) {
          // A tap: go to whichever half was pressed.
          var r = seg.getBoundingClientRect();
          segPos = start;
          segAnimTo(ev.clientX > r.left + r.width / 2 ? 1 : 0);
          return;
        }
        var a = hist[0];
        var b = hist[hist.length - 1];
        var dt = Math.max(1, b.t - a.t);
        var vel = ((b.x - a.x) / dt) * 1000;
        var proj = pos + ((vel / 1000) * 0.998) / (1 - 0.998);
        segAnimTo(proj > w / 2 ? 1 : 0, vel);
      }
      seg.addEventListener('pointermove', mv);
      seg.addEventListener('pointerup', up);
      seg.addEventListener('pointercancel', up);
    });
    // Keyboard and assistive tech reach the two buttons directly.
    $$('[data-hl-seg-btn]', seg).forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (e.detail !== 0) return; // pointer taps are handled above
        segAnimTo(b.getAttribute('data-hl-seg-btn') === 'mto' ? 1 : 0);
      });
    });
  }

  // A sideways swipe on the swatch row switches group.
  if (swatchWrap) {
    swatchWrap.addEventListener('pointerdown', function (e) {
      if (segSingle()) return;
      var x0 = e.clientX;
      var y0 = e.clientY;
      var done = false;
      function mv(ev) {
        if (done) return;
        var dx = ev.clientX - x0;
        if (Math.abs(dx) > 24 && Math.abs(dx) > Math.abs(ev.clientY - y0)) {
          done = true;
          swatchWrap.__swiped = true;
          segAnimTo(dx < 0 ? 1 : 0);
        }
      }
      function up() {
        window.removeEventListener('pointermove', mv);
        window.removeEventListener('pointerup', up);
        window.removeEventListener('pointercancel', up);
        setTimeout(function () {
          swatchWrap.__swiped = false;
        }, 0);
      }
      window.addEventListener('pointermove', mv);
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
    });
  }

  function isLight(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
    if (!m) return false;
    var n = parseInt(m[1], 16);
    var r = (n >> 16) / 255;
    var g = ((n >> 8) & 255) / 255;
    var b = (n & 255) / 255;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.62;
  }

  // Re-judge every colour against the current choice of the other options,
  // count the groups and show the active one's swatches.
  function paintSwatches() {
    if (!colour) return;
    var counts = { in: 0, mto: 0 };
    var buttons = $$('[data-hl-sw]', colour);
    buttons.forEach(function (b) {
      var v = closest(sel, cIdx, b.getAttribute('data-value'));
      var g = groupOf(v);
      b.setAttribute('data-group', g);
      if (g !== 'out') counts[g] += 1;
      if (v && v.color) b.style.setProperty('--sw', v.color);
      b.classList.toggle('is-light', isLight(v && v.color));
    });
    if (seg) {
      ['in', 'mto'].forEach(function (k) {
        var btn = $('[data-hl-seg-btn="' + k + '"]', seg);
        var n = $('[data-hl-seg-n="' + k + '"]', seg);
        if (n) n.textContent = counts[k];
        if (btn) btn.hidden = counts[k] === 0;
      });
      var single = counts.in === 0 || counts.mto === 0;
      seg.toggleAttribute('data-single', single);
      if (counts[activeGroup] === 0) {
        activeGroup = counts.in ? 'in' : 'mto';
      }
      paintSegButtons();
      if (segPos == null) placeThumb();
    }
    var cur = sel[cIdx];
    buttons.forEach(function (b) {
      var g = b.getAttribute('data-group');
      var val = b.getAttribute('data-value');
      // Sold-out colours stay visible, struck through, at the end of In stock.
      b.hidden = g === 'out' ? activeGroup !== 'in' : g !== activeGroup;
      b.disabled = g === 'out';
      var on = val === cur;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var disp = $('[data-hl-colour-dispatch]', colour);
    if (disp) {
      disp.textContent = activeGroup === 'mto' ? 'Dispatch in 8–12 weeks' : 'Dispatch in 2–4 days';
      // Green for ready now, red for the 8-12 week wait.
      disp.classList.toggle('is-mto', activeGroup === 'mto');
    }
  }

  if (colour) {
    colour.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hl-sw]');
      if (!b || b.disabled || (swatchWrap && swatchWrap.__swiped)) return;
      var v = closest(sel, cIdx, b.getAttribute('data-value'));
      if (v) select(v);
    });
  }

  /* ================= Other options (Size etc.) ================= */

  function paintPills() {
    $$('[data-hl-pdp-option]').forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-option-index'), 10);
      $$('[data-hl-opt-val]', row).forEach(function (b) {
        var val = b.getAttribute('data-hl-opt-val');
        var on = sel[idx] === val;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        // Offered only if some variant has it with the current colour.
        var exists = variants.some(function (v) {
          return v.options[idx] === val && (cIdx < 0 || v.options[cIdx] === sel[cIdx]);
        });
        b.disabled = !exists && !on;
      });
    });
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hl-opt-val]');
    if (!b || b.disabled) return;
    var row = b.closest('[data-hl-pdp-option]');
    var idx = parseInt(row.getAttribute('data-option-index'), 10);
    var v = closest(sel, idx, b.getAttribute('data-hl-opt-val'));
    if (v) select(v);
  });

  /* ================= Applying a variant ================= */

  var addBtn = $('[data-hl-pdp-add]');
  var qtyInput = $('[data-hl-qty-input]');
  var addedTimer = 0;

  function qty() {
    var n = parseInt(qtyInput && qtyInput.value, 10);
    return n > 0 ? n : 1;
  }

  function statusHtml(v) {
    if (data.preorder) {
      return (
        '<span class="hl1a-status__dot hl1a-status__dot--ring" aria-hidden="true"></span><span><strong>Pre-order.</strong> Arrives ' +
        esc(data.preorderEta || 'soon') +
        ". We'll be in touch to book your delivery as soon as it lands.</span>"
      );
    }
    var g = groupOf(v);
    if (g === 'mto' && !v.available) {
      return '<span class="hl1a-status__dot hl1a-status__dot--ring hl1a-status__dot--mto" aria-hidden="true"></span><span><strong class="hl1a-status__mto">Made to order.</strong> This colour can’t be ordered online yet. Call your nearest showroom and we’ll order it in, dispatched in 8–12 weeks.</span>';
    }
    if (g === 'out') {
      return '<span class="hl1a-status__dot hl1a-status__dot--out" aria-hidden="true"></span><span><strong>Sold out.</strong> Call your nearest showroom and we’ll let you know when it’s back.</span>';
    }
    if (g === 'mto') {
      return '<span class="hl1a-status__dot hl1a-status__dot--ring hl1a-status__dot--mto" aria-hidden="true"></span><span><strong class="hl1a-status__mto">Made to order.</strong> Dispatched in 8–12 weeks. We’ll be in touch when it’s ready to book your delivery.</span>';
    }
    if (data.postable) {
      return '<span class="hl1a-status__dot hl1a-status__dot--in" aria-hidden="true"></span><span><strong class="hl1a-status__in">In stock.</strong> Posted Australia-wide, postage calculated at checkout.</span>';
    }
    return '<span class="hl1a-status__dot hl1a-status__dot--in" aria-hidden="true"></span><span><strong class="hl1a-status__in">In stock.</strong> Order today, dispatched in 2–4 days. We’ll be in touch within one business day to book your delivery.</span>';
  }

  function propsFor(v) {
    var special = isSpecial(v);
    var p = {
      _hl_postable: data.postable ? 'true' : 'false',
      _hl_heavy: data.heavy ? 'true' : 'false',
      _hl_special_order: special ? 'true' : 'false'
    };
    if (special) p.Dispatch = 'Made to order, 8-12 weeks';
    return p;
  }

  function paintAddLabel() {
    if (!addBtn || addBtn.classList.contains('is-added')) return;
    var v = current;
    var custom = !!v && v.available && groupOf(v) === 'mto' && !data.preorder;
    if (!v || !v.available) {
      addBtn.disabled = true;
      addBtn.textContent = !v ? 'Unavailable' : zeroStock(v) ? 'Call to order' : 'Sold out';
    } else {
      addBtn.disabled = false;
      addBtn.textContent = (custom ? 'Place custom order · ' : 'Add to cart · ') + money(v.price * qty());
    }
    // A made-to-order colour is a custom order: its own wording and a brown
    // button, so nobody mistakes it for something ready to dispatch.
    addBtn.classList.toggle('is-custom', custom);
    if (sbAdd) {
      sbAdd.disabled = !v || !v.available;
      sbAdd.classList.toggle('is-custom', custom);
      if (!sbAdd.classList.contains('is-added')) {
        sbAdd.textContent = v && v.available ? (custom ? 'Place custom order' : 'Add to cart') : v && zeroStock(v) ? 'Call to order' : 'Sold out';
      }
    }
  }

  function select(v, opts) {
    current = v;
    sel = v.options.slice();
    if (idInput) idInput.value = v.id;

    var now = $('[data-hl-pdp-now]');
    var sale = v.compare > v.price;
    if (now) {
      now.textContent = money(v.price);
      now.classList.toggle('is-sale', sale);
    }
    var rrp = $('[data-hl-pdp-rrp]');
    if (rrp) {
      rrp.hidden = !sale;
      var rv = $('[data-hl-pdp-rrp-val]');
      if (rv && sale) rv.textContent = money(v.compare);
    }
    var ap = $('[data-hl-pdp-afterpay] strong');
    if (ap) ap.textContent = money(Math.round(v.price / 4));

    var st = $('[data-hl-pdp-status]');
    if (st) st.innerHTML = statusHtml(v);

    var props = $('[data-hl-pdp-props]');
    if (props) {
      var p = propsFor(v);
      props.innerHTML = Object.keys(p)
        .map(function (k) {
          return '<input type="hidden" name="properties[' + esc(k) + ']" value="' + esc(p[k]) + '">';
        })
        .join('');
    }

    var cv = colour && $('[data-hl-colour-val]', colour);
    if (cv) cv.textContent = colourName(v);

    // A pick from the other group moves the control to it.
    if (colour && seg && !segSingle()) {
      var g = groupOf(v);
      if (g === 'in' || g === 'mto') {
        if (g !== activeGroup) segAnimTo(g === 'mto' ? 1 : 0);
      }
    }
    paintSwatches();
    paintPills();
    paintAddLabel();
    paintBar();

    if (v.mediaId != null) gallery.toMedia(v.mediaId, opts && opts.silent);

    if (!(opts && opts.silent) && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url.toString());
    }
    root.dispatchEvent(new CustomEvent('hl-pdp:variant', { bubbles: true, detail: { variant: v } }));
  }

  /* ================= Gallery ================= */

  var gallery = (function () {
    var stage = $('.hl1a-gal__stage');
    var track = $('[data-hl-gal-track]');
    var slides = $$('[data-hl-gal-slide]');
    var dots = $$('[data-hl-gal-dot]');
    var thumbs = $$('[data-hl-gal-thumb]');
    var idx = 0;
    var n = slides.length;

    var fadeT = 0;
    function place(instant) {
      if (instant) track.classList.add('is-dragging');
      track.style.transform = 'translateX(' + -idx * 100 + '%)';
      if (instant) {
        void track.offsetWidth;
        track.classList.remove('is-dragging');
      }
    }

    // Next / previous slide across. A longer jump (a colour pick, a far
    // thumbnail) fades straight to the photo instead of sliding past every
    // photo in between.
    function go(i, instant) {
      if (!track || !n) return;
      if (typeof zoomOut === 'function') zoomOut();
      var from = idx;
      idx = ((i % n) + n) % n;
      clearTimeout(fadeT);
      if (!instant && Math.abs(idx - from) > 1 && !noMotion()) {
        stage.classList.add('is-fading');
        fadeT = setTimeout(function () {
          place(true);
          stage.classList.remove('is-fading');
        }, 140);
      } else {
        stage.classList.remove('is-fading');
        place(instant);
      }
      slides.forEach(function (s, k) {
        if (k === idx) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === idx);
        d.setAttribute('aria-selected', k === idx ? 'true' : 'false');
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === idx);
        t.setAttribute('aria-pressed', k === idx ? 'true' : 'false');
      });
    }

    var prev = $('[data-hl-gal-prev]');
    var next = $('[data-hl-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hl-gal-dot'), 10)); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-hl-gal-thumb'), 10)); });
    });

    // Swipe: the track follows the finger, then settles on the nearer slide.
    if (stage && n > 1) {
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('button')) return;
        // Zoomed in, a drag looks around the photo rather than changing it.
        if (zoomed) return;
        var x0 = e.clientX;
        var y0 = e.clientY;
        var w = stage.offsetWidth || 1;
        var dragging = false;
        var dead = false;
        var t0 = performance.now();
        var dx = 0;
        function mv(ev) {
          if (dead) return;
          dx = ev.clientX - x0;
          var dy = ev.clientY - y0;
          if (!dragging) {
            if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) {
              dead = true;
              return;
            }
            if (Math.abs(dx) < 6) return;
            dragging = true;
            track.classList.add('is-dragging');
            try {
              stage.setPointerCapture(ev.pointerId);
            } catch (err) {}
          }
          var edge = (idx === 0 && dx > 0) || (idx === n - 1 && dx < 0) ? 0.35 : 1;
          track.style.transform = 'translateX(calc(' + -idx * 100 + '% + ' + dx * edge + 'px))';
        }
        function up() {
          stage.removeEventListener('pointermove', mv);
          stage.removeEventListener('pointerup', up);
          stage.removeEventListener('pointercancel', up);
          if (!dragging) return;
          // A swipe is not a click: keep the viewer from opening.
          stage.__swiped = true;
          setTimeout(function () {
            stage.__swiped = false;
          }, 0);
          track.classList.remove('is-dragging');
          var fast = Math.abs(dx) / Math.max(1, performance.now() - t0) > 0.4;
          var target = idx;
          if (Math.abs(dx) > w * 0.2 || (fast && Math.abs(dx) > 20)) target = dx < 0 ? idx + 1 : idx - 1;
          target = Math.max(0, Math.min(n - 1, target));
          go(target);
        }
        stage.addEventListener('pointermove', mv);
        stage.addEventListener('pointerup', up);
        stage.addEventListener('pointercancel', up);
      });
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    /* ----- Zoom in place: click the photo to zoom it inside its own frame ----- */

    var zoomed = false;

    function zoomImg() {
      var s = slides[idx];
      return s ? s.querySelector('img') : null;
    }

    // The zoomed photo looks at whatever is under the pointer or finger.
    function aim(e) {
      var img = zoomImg();
      if (!img) return;
      var r = stage.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
    }

    function zoomIn(e) {
      var img = zoomImg();
      if (!img) return;
      var slide = slides[idx];
      // Swap in the large rendition the first time this photo is zoomed.
      var big = slide.getAttribute('data-zoom-src');
      if (big && !img.__hlBig) {
        img.__hlBig = true;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = big;
      }
      aim(e);
      zoomed = true;
      stage.classList.add('is-zoomed');
    }

    function zoomOut() {
      if (!zoomed) return;
      zoomed = false;
      stage.classList.remove('is-zoomed');
    }

    if (stage) {
      stage.classList.add('is-zoomable');
      stage.addEventListener('click', function (e) {
        if (stage.__swiped || e.target.closest('button')) return;
        if (zoomed) zoomOut();
        else zoomIn(e);
      });
      stage.addEventListener('pointermove', function (e) {
        if (zoomed) aim(e);
      });
      // Leaving the frame zooms out for a mouse only: a tap is followed by
      // compatibility leave events that would undo it straight away.
      stage.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') zoomOut();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') zoomOut();
      });
    }

    return {
      toMedia: function (mediaId, instant) {
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
            go(i, instant);
            return;
          }
        }
      },
      go: go
    };
  })();

  /* ================= Quantity ================= */

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hl-qty]');
    if (!b || !qtyInput) return;
    qtyInput.value = Math.max(1, qty() + parseInt(b.getAttribute('data-hl-qty'), 10));
    paintAddLabel();
  });
  if (qtyInput) {
    qtyInput.addEventListener('input', paintAddLabel);
    qtyInput.addEventListener('change', function () {
      qtyInput.value = qty();
      paintAddLabel();
    });
  }

  /* ================= Cart ================= */

  function cartEl() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function cartUrl(path) {
    var r = window.routes || {};
    if (path === 'add') return r.cart_add_url || '/cart/add';
    return r.cart_url || '/cart';
  }

  function afterAdd(res, cart) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: current && current.id, cartData: res });
    }
    if (cart && res.sections && cart.renderContents) {
      cart.classList.remove('is-empty');
      cart.renderContents(res);
    } else {
      fetch(cartUrl() + '.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.dispatchEvent(new CustomEvent('hl-cart:changed', { detail: { cart: c } }));
          // Pieces, not lines: item_count includes delivery / rubbish charges.
          var pieces = window.hlCartPieces ? window.hlCartPieces(c) : c.item_count;
          $$('.hl-header__cart-count', document).forEach(function (el) { el.textContent = pieces; });
        })
        .catch(function () {});
    }
  }

  function showError(el, msg) {
    if (!el) return;
    el.textContent = msg || 'Sorry, this piece could not be added to your cart.';
    el.hidden = false;
  }

  function flashAdded(btn, restore) {
    if (!btn) return;
    clearTimeout(btn.__hlT);
    btn.classList.add('is-added');
    btn.textContent = 'Added to cart';
    btn.__hlT = setTimeout(function () {
      btn.classList.remove('is-added');
      restore();
    }, 1800);
  }

  var form = $('[data-hl-pdp-form]');
  function addMain(sourceBtn) {
    if (!form || !current || !current.available) return;
    var errEl = $('[data-hl-pdp-error]');
    if (errEl) errEl.hidden = true;
    var cart = cartEl();
    var fd = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(sourceBtn || addBtn);
    }
    var btns = [addBtn, sbAdd].filter(Boolean);
    btns.forEach(function (b) {
      b.classList.add('is-loading');
      b.disabled = true;
    });
    fetch(cartUrl('add'), {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btns.forEach(function (b) {
          b.classList.remove('is-loading');
          b.disabled = false;
        });
        if (res.status) {
          showError(errEl, res.description || res.message);
          paintAddLabel();
          return;
        }
        flashAdded(addBtn, paintAddLabel);
        flashAdded(sbAdd, paintAddLabel);
        afterAdd(res, cart);
      })
      .catch(function () {
        btns.forEach(function (b) {
          b.classList.remove('is-loading');
          b.disabled = false;
        });
        showError(errEl);
        paintAddLabel();
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addMain(addBtn);
    });
  }

  /* ================= Jump links ================= */

  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hl-pdp-goto], [data-hl-pdp-goto-delivery]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('data-hl-pdp-goto') || '#hl-pdp-delivery');
    if (!target) return;
    e.preventDefault();
    smoothTo(target);
  });

  /* ================= Key features slider ================= */

  (function () {
    var kf = $('[data-hl-kf]');
    if (!kf) return;
    var track = $('[data-hl-kf-track]', kf);
    var prev = $('[data-hl-kf-prev]', kf);
    var next = $('[data-hl-kf-next]', kf);
    if (!track) return;

    function paint() {
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function by(dir) {
      track.scrollBy({ left: dir * 244, behavior: noMotion() ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
    track.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();

    // Mouse drag on desktop; touch keeps native scrolling.
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var x0 = e.clientX;
      var l0 = track.scrollLeft;
      track.classList.add('is-dragging');
      function mv(ev) {
        track.scrollLeft = l0 - (ev.clientX - x0);
      }
      function up() {
        window.removeEventListener('pointermove', mv);
        window.removeEventListener('pointerup', up);
        var step = 122;
        var target = Math.round(track.scrollLeft / step) * step;
        track.scrollTo({ left: target, behavior: noMotion() ? 'auto' : 'smooth' });
        setTimeout(function () {
          track.classList.remove('is-dragging');
        }, 350);
      }
      window.addEventListener('pointermove', mv);
      window.addEventListener('pointerup', up);
    });
  })();

  /* ================= Delivery and assembly ================= */

  (function () {
    var deliv = $('[data-hl-pdp-deliv]');
    if (!deliv) return;
    var zonesEl = $('[data-hl-pdp-zones]', deliv);
    var zones = [];
    try {
      zones = JSON.parse(zonesEl.textContent);
    } catch (e) {}
    zones.forEach(function (z) {
      z.ranges = String(z.postcodes || '')
        .split(',')
        .map(function (r) {
          var q = r.trim().split('-').map(Number);
          return [q[0], q[1] == null || isNaN(q[1]) ? q[0] : q[1]];
        })
        .filter(function (q) { return !isNaN(q[0]); });
    });

    var list = $('[data-hl-zone-list]', deliv);
    if (list) {
      list.innerHTML = zones
        .map(function (z, i) {
          return '<li data-zone="' + i + '"><span>' + esc(z.name) + '</span><span>' + money((z.fee || 0) * 100) + '</span></li>';
        })
        .join('');
    }

    var formEl = $('[data-hl-pc-form]', deliv);
    var input = $('[data-hl-pc-input]', deliv);
    var out = $('[data-hl-pc-result]', deliv);

    function zoneFor(pc) {
      var n = parseInt(pc, 10);
      // First match wins: the table lists narrow zones before Brisbane.
      for (var i = 0; i < zones.length; i++) {
        for (var j = 0; j < zones[i].ranges.length; j++) {
          var r = zones[i].ranges[j];
          if (n >= r[0] && n <= r[1]) return i;
        }
      }
      return -1;
    }

    function check(pc, restoring) {
      pc = String(pc || '').trim();
      $$('li', list).forEach(function (li) { li.classList.remove('is-match'); });
      if (!/^\d{4}$/.test(pc)) {
        out.innerHTML = '<strong>Enter a 4-digit postcode.</strong>';
        return;
      }
      var i = zoneFor(pc);
      if (i < 0) {
        out.innerHTML = '<strong>' + esc(pc) + ' is outside our delivery zones.</strong> Call your nearest showroom and we’ll talk through options.';
        return;
      }
      var z = zones[i];
      out.innerHTML = '<strong>' + esc(z.name) + ', ' + money((z.fee || 0) * 100) + '.</strong> Delivered and fully assembled in your home.';
      var li = list && list.querySelector('[data-zone="' + i + '"]');
      if (li) li.classList.add('is-match');
      if (!restoring) {
        try {
          var o = JSON.parse(localStorage.getItem(OPTS_KEY)) || {};
          o.postcode = pc;
          localStorage.setItem(OPTS_KEY, JSON.stringify(o));
        } catch (e) {}
      }
    }

    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        check(input.value);
      });
    }
    if (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 4);
      });
    }
    // A postcode the shopper already gave (here, the delivery band or the
    // cart) is checked straight away.
    try {
      var saved = String((JSON.parse(localStorage.getItem(OPTS_KEY)) || {}).postcode || '');
      if (/^\d{4}$/.test(saved) && input) {
        input.value = saved;
        check(saved, true);
      }
    } catch (e) {}
  })();

  /* ================= Complete the room ================= */

  (function () {
    var room = $('[data-hl-room]');
    if (!room) return;
    var cardsEl = $('[data-hl-room-cards]', room);
    var linesEl = $('[data-hl-room-lines]', room);
    var totalEl = $('[data-hl-room-total]', room);
    var btn = $('[data-hl-room-add]', room);
    var errEl = $('[data-hl-room-error]', room);
    var base = room.getAttribute('data-url');

    function load(url) {
      return fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('[data-hl-room-src] [data-hl-rc]'));
        })
        .catch(function () {
          return [];
        });
    }

    function ticked() {
      return $$('[data-hl-rc]', cardsEl).filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; });
    }

    function paint() {
      var items = ticked();
      var mainPrice = current ? current.price * qty() : 0;
      var total = mainPrice;
      var html = '<li><span>' + esc(data.title) + '</span><span>' + money(mainPrice) + '</span></li>';
      items.forEach(function (c) {
        var p = parseInt(c.getAttribute('data-price'), 10) || 0;
        total += p;
        html += '<li><span>' + esc(c.getAttribute('data-title')) + '</span><span>' + money(p) + '</span></li>';
      });
      linesEl.innerHTML = html;
      totalEl.textContent = money(total);
      if (!btn.classList.contains('is-added')) btn.textContent = 'Add ' + (items.length + 1) + ' to cart';
      btn.disabled = !current || !current.available;
    }

    function showCards(cards) {
      if (!cards.length) return;
      cards.slice(0, 3).forEach(function (c, i) {
        var node = c.parentNode === cardsEl ? c : document.importNode(c, true);
        // The first two start ticked.
        node.setAttribute('aria-pressed', i < 2 ? 'true' : 'false');
        if (node.parentNode !== cardsEl) cardsEl.appendChild(node);
      });
      room.hidden = false;
      paint();
    }

    // The section pairs pieces itself (a sofa gets tables, a dining table
    // gets chairs). Only a piece it has no pairing for asks Shopify.
    var serverCards = $$('[data-hl-rc]', cardsEl);
    if (serverCards.length) {
      showCards(serverCards);
    } else {
      load(base + '&intent=complementary')
        .then(function (cards) {
          return cards.length ? cards : load(base);
        })
        .then(showCards);
    }

    cardsEl.addEventListener('click', function (e) {
      var c = e.target.closest('[data-hl-rc]');
      if (!c) return;
      c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      paint();
    });
    // The other pieces of a set follow the colour on screen (data-colours,
    // from snippets/hl-room-card): variant, price, photo and dispatch line.
    function followColour(v) {
      if (!v || data.colourIndex < 0 || !v.options) return;
      var colour = v.options[data.colourIndex];
      $$('[data-hl-rc][data-colours]', cardsEl).forEach(function (c) {
        var map;
        try {
          map = JSON.parse(c.getAttribute('data-colours'));
        } catch (e) {
          return;
        }
        var m = map && map[colour];
        if (!m || !m.available) return;
        var q = parseInt(c.getAttribute('data-qty'), 10) || 1;
        c.setAttribute('data-variant-id', m.id);
        c.setAttribute('data-price', m.price * q);
        var priceEl = $('[data-hl-rc-price]', c);
        if (priceEl) priceEl.textContent = money(m.price * q);
        var props = {};
        try {
          props = JSON.parse(c.getAttribute('data-props')) || {};
        } catch (e) {}
        props._hl_special_order = m.special ? 'true' : 'false';
        if (m.special) props.Dispatch = 'Made to order, 8-12 weeks';
        else delete props.Dispatch;
        c.setAttribute('data-props', JSON.stringify(props));
        var img = $('img', c);
        if (img && m.img) {
          img.removeAttribute('srcset');
          img.src = m.img;
        }
      });
    }
    root.addEventListener('hl-pdp:variant', function (e) {
      followColour(e.detail && e.detail.variant);
      if (!room.hidden) paint();
    });
    if (qtyInput) qtyInput.addEventListener('input', function () { if (!room.hidden) paint(); });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-hl-qty]') && !room.hidden) paint();
    });

    btn.addEventListener('click', function () {
      if (!current || !current.available) return;
      errEl.hidden = true;
      var items = [{ id: current.id, quantity: qty(), properties: propsFor(current) }];
      ticked().forEach(function (c) {
        var props = {};
        try {
          props = JSON.parse(c.getAttribute('data-props')) || {};
        } catch (err) {}
        items.push({ id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: parseInt(c.getAttribute('data-qty'), 10) || 1, properties: props });
      });
      var cart = cartEl();
      var body = { items: items };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(btn);
      }
      btn.disabled = true;
      fetch(cartUrl('add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.disabled = false;
          if (res.status) {
            showError(errEl, res.description || res.message);
            return;
          }
          flashAdded(btn, paint);
          afterAdd(res, cart);
        })
        .catch(function () {
          btn.disabled = false;
          showError(errEl);
        });
    });
  })();

  /* ================= Sticky Add to cart bar ================= */

  var bar = $('[data-hl-pdp-sb]');
  var sbAdd = bar && $('[data-hl-sb-add]', bar);

  function paintBar() {
    if (!bar || !current) return;
    var meta = $('[data-hl-sb-meta]', bar);
    var g = groupOf(current);
    var label = data.preorder ? 'Pre-order' : g === 'out' ? 'Sold out' : g === 'mto' ? 'Made to order' : 'In stock';
    var parts = [];
    var s = seriesOf(current);
    var val = cIdx >= 0 ? current.options[cIdx] : '';
    if (s) {
      parts.push(esc(s));
      if (val) parts.push(esc(val.indexOf(s) === 0 ? val.slice(s.length).trim() : val));
    } else if (val) {
      parts.push(esc(val));
    }
    parts.push('<strong' + (g === 'in' && !data.preorder ? ' class="is-in"' : '') + '>' + label + '</strong>');
    if (meta) meta.innerHTML = parts.join(' · ');
    var price = $('[data-hl-sb-price]', bar);
    var mprice = $('[data-hl-sb-mprice]', bar);
    if (price) price.textContent = money(current.price);
    if (mprice) mprice.textContent = money(current.price);
    var th = $('[data-hl-sb-thumb]', bar);
    if (th && current.thumb) th.src = current.thumb;
  }

  if (bar) {
    // Out of the section: a transformed ancestor would pin a fixed element to
    // itself instead of the window.
    document.body.appendChild(bar);
    document.body.classList.add('hl1a-sb-page');
    if (sbAdd) sbAdd.addEventListener('click', function () { addMain(sbAdd); });

    var anchor = form || addBtn;
    var shown = false;
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
    }
    var io = null;
    function observe() {
      if (io) io.disconnect();
      if (!('IntersectionObserver' in window) || !anchor) return;
      io = new IntersectionObserver(
        function (entries) {
          var e = entries[entries.length - 1];
          // Shown once the button row's bottom has passed under the header.
          setShown(!e.isIntersecting && e.boundingClientRect.bottom < headerH() + 1);
        },
        { rootMargin: '-' + headerH() + 'px 0px 0px 0px', threshold: 0 }
      );
      io.observe(anchor);
    }
    // The observer only fires when the row crosses the line; a jump straight
    // from above the header to below the fold (back to top, an anchor link)
    // crosses nothing, so a scroll check settles it too.
    var ticking = false;
    function recheck() {
      ticking = false;
      if (!anchor) return;
      setShown(anchor.getBoundingClientRect().bottom < headerH() + 1);
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(recheck);
        }
      },
      { passive: true }
    );
    observe();
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', observe);
  }

  /* ================= First paint ================= */

  if (current) select(current, { silent: true });
  placeThumb();
  window.addEventListener('resize', placeThumb);
})();
